/**
 * TaxNotificationsPage - Tax notification management dashboard
 *
 * Surfaces the TaxNotificationDashboard from @ferp/workflow-forms for payroll administrators.
 * Provides tax notification management, compliance tracking, and regulatory updates.
 *
 * Route: /payroll/tax-notifications
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconReceipt2 } from '@tabler/icons-react';

import { TaxNotificationDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function TaxNotificationsPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="orange">
            <IconReceipt2 size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Tax Notifications</Title>
            <Text size="sm" c="dimmed">
              Tax notification management, compliance tracking, and regulatory updates
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <TaxNotificationDashboard />
    </Container>
  );
}

export default TaxNotificationsPage;
